import { FC } from "react";

import { ICoursesCalendarSlotDto } from "@ryde/shared";

import { CoursesCalendar } from "../calendar";
import { CalendarCoursesPanelBodyStyled } from "./courses.panel.styled";

interface ICoursesPanelCalendar {
  slots: ICoursesCalendarSlotDto[];
  onCreateSlotRide: (slot: ICoursesCalendarSlotDto) => Promise<number>;
  onAfterSlotProduce?: () => void;
}

export const CoursesPanelCalendar: FC<ICoursesPanelCalendar> = ({
  slots,
  onCreateSlotRide,
  onAfterSlotProduce,
}) => {
  return (
    <CalendarCoursesPanelBodyStyled>
      <CoursesCalendar
        slots={slots}
        onCreateSlotRide={onCreateSlotRide}
        onAfterSlotProduce={onAfterSlotProduce}
      />
    </CalendarCoursesPanelBodyStyled>
  );
};
